import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import optimizeImage from '@/services/ImageOptimize';
export default defineComponent({
    name: 'image-gallery-mobile',
    components: {
        Carousel,
        Slide,
        Pagination,
    },
    data: () => ({
        currentSlide: 0,
    }),
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), mapGetters('global', {
        isMobile: 'isMobile',
    })), { allImages() {
            if (this.currentProduct === null) {
                return [];
            }
            const images = [];
            images.push(this.currentProduct.mainImage);
            this.currentProduct.images.forEach((src) => {
                src = src.replace('thumbnail_images', 'original_images').replace('popup_images', 'original_images');
                images.push(src);
            });
            return images;
        } }),
    methods: {
        optimizeImage,
        triggerFancyBox() {
            const gallery = this.allImages.map((image) => {
                const full = image
                    .replace('popup_images', 'original_images')
                    .replace('thumbnail_images', 'original_images');
                const thumb = optimizeImage(image, 400);
                return {
                    src: full,
                    thumb: thumb,
                };
            });
            Fancybox.show(gallery, {
                on: {
                    'Carousel.ready': (fancyBox) => {
                        fancyBox.jumpTo(this.currentSlide);
                    },
                },
            });
        },
    },
});
